module.exports = __webpack_public_path__ + "static/img/公司19.e6f8ef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司19.jpg
// module id = 1iEo
// module chunks = 1